import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { useContent } from "../../context/ContentContext";
import { authFetch } from "../../data/api";

// Shared state/logic for editing one content section (company, hero, ...).
export function useSection(key, logout) {
  const { content, applyContent } = useContent();
  const [draft, setDraft] = useState(content[key]);
  const [saving, setSaving] = useState(false);

  // Re-sync the draft when the live content changes (e.g. after a save/refresh).
  useEffect(() => {
    setDraft(content[key]);
  }, [content, key]);

  const save = useCallback(async () => {
    setSaving(true);
    try {
      const res = await authFetch(`/admin/content/${key}`, { method: "PUT", body: draft });
      applyContent(res.content);
      toast.success("Modifiche salvate");
    } catch (err) {
      toast.error(err.detail || "Errore nel salvataggio");
      if (err.status === 401 && logout) logout();
    } finally {
      setSaving(false);
    }
  }, [draft, key, applyContent, logout]);

  return { draft, setDraft, saving, save };
}
